import { render, staticRenderFns } from "./Escolaridades.vue?vue&type=template&id=592c7694&"
import script from "./Escolaridades.vue?vue&type=script&lang=js&"
export * from "./Escolaridades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports